import JSEncrypt from 'jsencrypt/bin/jsencrypt'

const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJzx4l8B6L3uBFRuqPLUu9MHnOTxyiE6C8llTs4N2uf1JIPgmNVAoY/PFdgobYf96BEaA32Pr3oS+OsPLuZfMvECAwEAAQ=='

const privateKey = 'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAMdPqer6+wt6E9+t\n' +
    'xqo1t+cidKWXvT15OTUS4C8HoKQpcweYtrfyHmLxNdOpGo+Zr1HxoNwvRAIiXB8R\n' +
    'wLwWXPJ+sDSaNzt3ynv8N9iws3Kr4ls1pa1mVw8RwWzSR3cltSV0gQYmpqpXl7jE\n' +
    '1oi6Yg3M3rjtNuIJ94KJN04uQ7K/AgMBAAECgYAuFuLxHra88a7006eUJrXvMg2N\n' +
    'WWh+dbDf8Ax9c6MXMyqRgCQIp2mVcbgDySAGQwDCz0BmiluMrstkt+M822MEm28C\n' +
    'CDtQ3kH3fCY/b6ZEsidsGm53M+jEiTwnYhhXKg0EUem5Rw72KGcXsNCzIajcrTGC\n' +
    'QKE4cqUVdDdTihJoEQJBAPsZeYgnHkLb0Mfuzu6936zJ9oaql8dR8PYRHHB+dd4k\n' +
    'rZRVA5lVXPbNZPxJpZx8Zp3+U4IjHL22qs5VCUT0MscCQQDLM3Kqul42/vUFVGnb\n' +
    'zyfcCspxr8TJO9/TrtEpyuAqFaOx66ooxYzV6oFTezxeX9hN8CHQTb49Pn42sJxJ\n' +
    'nQhJAkEAh5McnFfKrfyzgI+/KQZZ05iEQ/et1Y+3k5Rvj4moKFYTZoh0VgDSHeuO\n' +
    'P+2fvpsoaNvdyOEeboxHMvqU86cKFwJAJS6M1OC1TKrqescvd6E4UfNHh/X5tDjY\n' +
    'hAuBCnys+AZtpajRwhQj6SC3+WabbUlscxZ1mYAgR2SgA7HdZzrswQJBAKoxSGt+\n' +
    'W+6PnB9uMJztxplqUZFO/sgUOqPoi7zdv8efhIHngqqyzswo+5HyTZnAlDmHDZLH\n' +
    '+BbgkthgkUgJn28='

// 加密
export function rsaEncrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(txt)
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey)
  return encryptor.decrypt(txt)
}
